import PropTypes from 'prop-types';
import React, { Component } from 'react';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import ArchivesLink from '../common/archives_link';
import renderClientSideOnly from '../hocs/renderClientSideOnly';
import Spinner from '../common/spinner';

export class UpdatedDate extends Component {
  archivesLink = () => (
    <ArchivesLink
      format="datetime"
      timestamp={this.props.published * 1000}
      eventLabel="updated date"
    />
  );

  modifiedArchivesDate = () => (
    <RosettaFormattedMessage parentFilename={__filename}
      id="last_updated"
      description='Text denoting when an article was "last updated"'
      defaultMessage="Last Updated {date}"
      values={{ date: this.archivesLink() }}
    />
  );

  publishedArchivesDate = () => (
    <RosettaFormattedMessage parentFilename={__filename}
      id="just_date"
      description="Text denoting the date an article was first published"
      defaultMessage="Published {date}"
      values={{ date: this.archivesLink() }}
    />
  );

  publishDate = () =>
    this.props.published !== this.props.original_published
      ? this.modifiedArchivesDate()
      : this.publishedArchivesDate();

  render = () => (
    <div className="byline modified">
      {this.publishDate()}
    </div>
  );
}

export default UpdatedDate;

UpdatedDate.propTypes = {
  original_published: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  published: PropTypes.number.isRequired
};
